import './add-to-cart-modal.scss';
import 'snippets/cart-js/ajax-add-cart';

class AddToCartModal extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll('.card__swatch--text-option').forEach((option) => {
            option.addEventListener('click', (event) => {
                event.stopPropagation();

                const variantTitle = option.getAttribute('data-swatch');
                const variantId = option.getAttribute('data-variant-id');
                this.updateModalForVariant(variantId, variantTitle);
            });
        });
    }

    updateModalForVariant(variantId, variantTitle) {
        const variantTitleElement = this.querySelector('.add-to-cart-variant-title');
        variantTitleElement.textContent = variantTitle;

        this.querySelectorAll('.card__swatch--text-option').forEach((option) => {
            option.classList.remove('selected');
            if(option.getAttribute('data-variant-id') === variantId) {
                option.classList.add('selected');
            }
        });

        const sellingPlan = this.querySelectorAll('.modal-selling-plan');
        sellingPlan.forEach((plan) => {
            plan.toggleRadioInputChecked(true);
            plan.querySelectorAll('input').forEach((input) => {
                input.checked = false;
            });

            if(plan.classList.contains(`modal-selling-plan--${variantId}`)) {
                plan.classList.remove('hidden');
                const manualInput = plan.querySelector('.manual-input');
                if(manualInput) {
                    manualInput.checked = true;
                }
            } else {
                plan.classList.add('hidden');
            }
        });


        const modalInputVariantId = this.querySelector('input[name="id"]');
        if(modalInputVariantId) {
            modalInputVariantId.value = variantId;
        }
    }
}

class SellingPlanSelection extends HTMLElement {
    constructor() {
        super();
        if(this.classList.contains('modal-selling-plan')) {
            this.querySelector('.manual-input')
                ?.addEventListener('click', () => this.toggleRadioInputChecked(true));
            this.querySelector('.subscribe-input')
                ?.addEventListener('click', () => this.toggleRadioInputChecked(false));
        }
    }

    toggleRadioInputChecked(hideSelect) {
        const sellingPlan = this.querySelector('.selling-plan-wrapper');

        if(!sellingPlan) return;

        if (hideSelect) {
            sellingPlan.classList.add('hidden');
        } else {
            sellingPlan.classList.remove('hidden');
        }
    }
}

customElements.define('add-to-cart-modal', AddToCartModal);
customElements.define('selling-plan', SellingPlanSelection);
